var _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "#FFEBF5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.9998 22.0633C32.2904 21.3088 32.8027 20.66 33.4693 20.2024C34.1359 19.7449 34.9254 19.5 35.734 19.5",
    stroke: "#702459",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4998 32C19.4998 38.5 23.9998 44.5 27.4998 44.5C27.4998 44.5 30.2421 44 31.9995 44C33.7569 44 36.4998 44.5 36.4998 44.5C39.9998 44.5 44.4998 38.5 44.4998 32C44.4997 30.5522 44.0807 29.1353 43.2931 27.9204C42.5055 26.7055 41.3832 25.7445 40.0615 25.1534C38.7398 24.5624 37.2752 24.3665 35.8447 24.5895C34.4141 24.8124 33.0791 25.4447 32 26.4099C30.9208 25.4447 29.5854 24.8124 28.1548 24.5895C26.7243 24.3665 25.2597 24.5624 23.938 25.1534C22.6163 25.7445 21.494 26.7055 20.7064 27.9204C19.9189 29.1353 19.4998 30.5522 19.4998 32Z",
    fill: "#ED64A6",
    stroke: "#ED64A6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.3c37e89a9aaf0726fd4e0ed55feb0493.svg";
export { ForwardRef as ReactComponent };